import {createContext, useState, useEffect, useContext} from "react"
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import showContext from "./ShowContext";

const AuthContext = createContext()

export default AuthContext;

export const AuthProvider = ({children}) => {

    let {hideLogin} = useContext(showContext)
    const navigate = useNavigate();
    
    // Backend URL configuration:
    // - Staging (remote): Uses REACT_APP_BASE_URL environment variable (set to Railway backend in staging.yml)
    // - Local development: Defaults to localhost:8000
    // - Dev deployment: TODO - BASE_URL must be updated manually for dev deployment (currently hardcoded to EC2 IP)
    //   For dev deployment, uncomment the line below and set it to the appropriate backend URL
    //   const BASE_URL = "http://18.214.213.52/"  // Dev deployment backend
    const BASE_URL = process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000"

    let [user, setUser] = useState(() => localStorage.getItem("authTokens") ? jwtDecode(localStorage.getItem("authTokens")) : null)
    let [authTokens, setAuthTokens] = useState(() => localStorage.getItem("authTokens") ? JSON.parse(localStorage.getItem("authTokens")) : null)
    let [loading, setLoading] = useState(true)

    let loginUser = async (event) => {
        event.preventDefault()
        let response = await fetch(`${BASE_URL}/api/token/`, {
            method: "POST",
            headers:{
                "Content-Type":"application/json"
            },
            body: JSON.stringify({"username":event.target.username.value, "password":event.target.password.value})
        })

        let data = await response.json()
        if (response.status === 200){
            setAuthTokens(data)
            setUser(jwtDecode(data.access))
            localStorage.setItem("authTokens", JSON.stringify(data))
            hideLogin()
            event.target.reset()
        } else {
            alert("Something went wrong!")
        }

    }

    let logoutUser = () =>{
        setUser(null)
        setAuthTokens(null)
        localStorage.removeItem("authTokens")

    }


    let contextData = {
        user:user,
        authTokens: authTokens,
        loginUser: loginUser,
        logoutUser:logoutUser,
        BASE_URL:BASE_URL,
    }

    useEffect(()=>{
    let updateToken = async () =>{
        console.log("token updated!")
        let response = await fetch(`${BASE_URL}/api/token/refresh/`, {
            method: "POST",
            headers:{
                "Content-Type":"application/json"
            },
            body: JSON.stringify({"refresh": authTokens?.refresh})
        })

        let data = await response.json()

        if (response.status === 200) {
            setAuthTokens(data)
            setUser(jwtDecode(data.access))
            localStorage.setItem("authTokens", JSON.stringify(data))
        } else {
            logoutUser()
        }
        if(loading){
            setLoading(false)
        }
    }
        if(loading && authTokens){
            updateToken()
        }

        const fourMinutes = 4 * 1000 * 60
        let interval = setInterval(()=>{
            if (authTokens) {
                updateToken()
            }
        }, fourMinutes)

        return () => clearInterval(interval)


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authTokens, loading])

    return(
        <AuthContext.Provider value={contextData}>
            {children}
        </AuthContext.Provider>
    )
}